import { Outlet, useOutletContext } from 'react-router-dom'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'

import contractVersions from 'modules/contracts/store/collections/contractVersions'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import EmployeeList from 'modules/timeoff/components/TimeoffPolicy/EmployeeList'
import { PolicyDetailTabs } from 'modules/timeoff/components/TimeoffPolicy/PolicyDetailTabs'
import type { RouteContextParams } from 'modules/timeoff/lib/routeContextParams'

const EmployeeListPage = () => {
  const { tabs, policy, loading } = useOutletContext<RouteContextParams>()

  const { loading: loadingContractVersions } = useAsyncData(
    () => contractVersions.fetch({ withCachedFetchParams: true }),
    []
  )

  return (
    <ResponsivePage.Body
      loading={loading || loadingContractVersions}
      error={null}
      showHeader={false}
    >
      <PolicyDetailTabs tabs={tabs} />
      <EmployeeList loadingPolicies={loading} policy={policy} contractVersions={contractVersions}>
        <Outlet />
      </EmployeeList>
    </ResponsivePage.Body>
  )
}

export default EmployeeListPage
